/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Resend_VerificationInputs */

const en_common_sign_resend_verification = /** @type {(inputs: Common_Sign_Resend_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend verification email`)
};

const zh_common_sign_resend_verification = /** @type {(inputs: Common_Sign_Resend_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新发送验证邮件`)
};

/**
* | output |
* | --- |
* | "Resend verification email" |
*
* @param {Common_Sign_Resend_VerificationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_resend_verification = /** @type {((inputs?: Common_Sign_Resend_VerificationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Resend_VerificationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_resend_verification(inputs)
	return zh_common_sign_resend_verification(inputs)
});
export { common_sign_resend_verification as "common.sign.resend_verification" }